/**
 * Composable for Google Analytics event tracking via Nuxt Scripts.
 *
 * All gtag calls are proxied and queued — safe to call during SSR or before
 * the GA script has loaded. In development (when no GA ID is configured) the
 * proxy silently no-ops.
 */
export function useAnalytics() {
  const { proxy } = useScriptGoogleAnalytics()

  function trackEvent(name: string, params?: Record<string, unknown>) {
    proxy.gtag('event', name, params)
  }

  return { proxy, trackEvent }
}
